export class InsuranceInfoResponseModel {
  crmInsuranceInfoId: number;
  crmPolicyHolderName: string;
  modifiedByUserInfoId: number;
}
